import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.selectOriginatorStep,
      callback: function ($$v) {
        _vm.selectOriginatorStep = $$v;
      },
      expression: "selectOriginatorStep"
    }
  }, [_vm.selectOriginatorStep ? _c('niota-classic-devices-add-item-selector', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.Applications.form.selectOriginatorStep'),
      "editedItem": _vm.editedItem,
      "list": _vm.originators,
      "type": 'originator'
    },
    on: {
      "close": function ($event) {
        _vm.selectOriginatorStep = false;
      },
      "item-selected": _vm.selectedOriginator,
      "reset-application": _vm.resetApplication
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.finalStep,
      callback: function ($$v) {
        _vm.finalStep = $$v;
      },
      expression: "finalStep"
    }
  }, [_vm.finalStep ? _c('niota-classic-devices-add-add', {
    attrs: {
      "item": _vm.editedItem,
      "originator": _vm.originator,
      "applicationId": _vm.editedItem.applicationId,
      "deviceTypes": _vm.deviceTypes,
      "datasourceType": _vm.datasourceType
    },
    on: {
      "close": function ($event) {
        _vm.refreshList();
        _vm.finalStep = false;
      },
      "addNewItem": function ($event) {
        _vm.finalStep = false;
        _vm.addNew = true;
      },
      "refreshList": _vm.refreshList,
      "reset-originator": _vm.resetOriginator
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.addNew,
      callback: function ($$v) {
        _vm.addNew = $$v;
      },
      expression: "addNew"
    }
  }, [_vm.addNew ? _c('niota-classic-devices-add-add-new', {
    attrs: {
      "editedItem": _vm.editedItem,
      "deviceTypes": _vm.deviceTypes,
      "datasourceType": _vm.datasourceType
    },
    on: {
      "close": function ($event) {
        _vm.addNew = false;
      },
      "refreshList": _vm.refreshList,
      "reset-originator": _vm.resetOriginator
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };